import { useMemo } from "react";
import DOMPurify from "dompurify";

type UseSanitizedHtmlOptions = {
  readonly allowedTags?: string[]
  // Added to DOMPurify's default attributes, never replacing them.
  readonly allowedAttributes?: string[]
};

const DEFAULT_ALLOWED_TAGS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "br",
  "strong",
  "em",
  "u",
  "s",
  "ul",
  "ol",
  "li",
  "span",
  "div",
  "a",
];

export const useSanitizedHtml = (
  html: string | null | undefined,
  options?: UseSanitizedHtmlOptions,
): string => {
  return useMemo(() => {
    if (!html) return "";

    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: options?.allowedTags ?? DEFAULT_ALLOWED_TAGS,
      ADD_ATTR: options?.allowedAttributes,
      ALLOW_UNKNOWN_PROTOCOLS: false,
    });
    // Depend on the allowedTags values, not the options object reference:
    // callers often pass a fresh literal (`allowedTags ? { allowedTags } : undefined`)
    // on every render, which would otherwise defeat the memoization.
  }, [html, options?.allowedTags, options?.allowedAttributes]);
};
